
export function SetApplicantTypeSectionVisibility(selectedPartnerSecType: string) {
    let availableValues: string[] = window.ETDR_RD.appConfig["Constants.AvailableTypesForApplicant"];

    if (jQuery.inArray(selectedPartnerSecType, availableValues) === -1) {
        $("#applicantTypeSection").hide();
    } else {
        $("#applicantTypeSection").show();
    }
}

export function SetIsCorporation(selectedApplicantType: string, isCorporationFieldId: string) {
    let byDefaultCorporationApplicantTypes: Array<string> = window.ETDR_RD.appConfig["Constants.ByDefaultCorporationApplicantTypes"];
    let $cbElem: JQuery = $('#' + isCorporationFieldId);

    if (byDefaultCorporationApplicantTypes.indexOf(selectedApplicantType) > -1) {
        if (!$cbElem.is(":checked")) {
            $cbElem.prop("checked", true);
            $cbElem.change();
        }
    }
    else {
        if ($cbElem.is(":checked")) {
            $cbElem.prop("checked", false);
            $cbElem.change();
        }
    }
}

export function SetPersonalDataFieldsMandatory(selectedPartnerSecType: string) {
    let extendedPersonalDataMandatoryForThesePartnerTypes: Array<string> = window.ETDR_RD.appConfig["Constants.ExtendedPersonalDataMandatoryForThesePartnerTypesOnBlue"];

    // If the user is on green side, then get the values from another location
    if (!extendedPersonalDataMandatoryForThesePartnerTypes) {
        extendedPersonalDataMandatoryForThesePartnerTypes = window.ETDR_RD.appConfig["Constants.ExtendedPersonalDataMandatoryForThesePartnerTypes"];
    }

    if (extendedPersonalDataMandatoryForThesePartnerTypes.indexOf(selectedPartnerSecType) > -1) {
        $('.birthdata-label').parent().not(':has(sup)').append('<sup class="required">*</sup>');
    } else {
        $('.birthdata-label').siblings('sup').remove();
    }
}

export function SwitchCorporationAndPersonaldataFields() {
    let $isCorporation: JQuery = $(".is-corporation-cb");

    if ($isCorporation.is(":checked")) {
        $("#corporationDataDiv").show();
        $("#personalData2").hide();
        $("#idsDiv").hide();
    } else {
        $("#corporationDataDiv").hide();
        $("#personalData2").show();
        $("#idsDiv").show();
    }
}

export function InitCopyPersonalDataButton($buttonSelector: JQuery, $fromSelector: string, $toSelector: string, nameTransform: Function) {
    $buttonSelector.click(() => {
        $($fromSelector + " input").each((index, input) => {
            let $input: JQuery = $(input);
            let name: string = $input.attr("name");
            let id: string = $input.parent().siblings('input.country-id').attr('value');

            if (name !== undefined) {
                name = nameTransform(name);
                let $pair: JQuery = $($toSelector + " input[name='" + name + "']");

                if ($pair.length === 1) {
                    $pair.parent().siblings('input.country-id').attr('value', id);
                    $pair.val($input.val()).change();
                }
            }
        });
    });
};

export function InitErintettPartnerEvents(applicantTypeSelector: string, partnerTypeSelector: string) {
    $(document).on('change', applicantTypeSelector, () => {
        let selectedApplicantType: string = $(applicantTypeSelector).val() as string;
        let isCorporationFieldId: string = $(applicantTypeSelector).attr('data-is-corporation-field-id') as string;

        SetPersonalDataFieldsMandatory('Applicant');
        SetIsCorporation(selectedApplicantType, isCorporationFieldId);
    });

    $(document).on('change', partnerTypeSelector, () => {
        let selectedPartnerType: string = $(partnerTypeSelector).val() as string;

        SetApplicantTypeSectionVisibility(selectedPartnerType);
    });
}

jQuery(() => {
    $(document).on("change", "#partner-type-dropdown", event => {
        let $userTypeList: JQuery<HTMLSelectElement> = $(event.target) as JQuery<HTMLSelectElement>;
        let elemId: string = $userTypeList[0].attributes['id'].value;
        let selectedPartnerSecType: string = $('#' + elemId).val() as string;

        $('.partner-type-dropdown').val(event.target.value);

        SetApplicantTypeSectionVisibility(selectedPartnerSecType);
        SetPersonalDataFieldsMandatory(selectedPartnerSecType);
    });

    $(document).on("change", ".is-corporation-cb", () => {
        SwitchCorporationAndPersonaldataFields();
    });
});
